import { render, staticRenderFns } from "./CustomerProductOrdersList.vue?vue&type=template&id=b5e21c7a&scoped=true&"
import script from "./CustomerProductOrdersList.vue?vue&type=script&lang=js&"
export * from "./CustomerProductOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProductOrdersList.vue?vue&type=style&index=0&id=b5e21c7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e21c7a",
  null
  
)

export default component.exports